import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { LoaderService } from './services/loader.service';
import { LoaderState } from './models/loader';


@Component({
    selector: 'max-loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.css'],
    standalone: true,
    imports: [CommonModule, ProgressBarModule, ProgressSpinnerModule]
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;

  private subscription!: Subscription;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) => {
      this.show = state.show;
      // TODO: LoggingService trace loader state
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
